import { Plus } from "lucide-react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";
import { FAQ } from "../data/content";
import { Reveal, SectionHead } from "./Reveal";
import { scrollToId } from "../lib/scroll";

export const Faq = () => (
  <section id="faq" className="relative py-28 lg:py-40" data-testid="faq-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <SectionHead eyebrow="Häufige Fragen" lines={["Antworten,", "bevor Sie fragen", "müssen."]} text="Alles Wichtige zu Lieferzeit, Nutzungsrechten, Korrekturen und Marktplatz-Richtlinien – kompakt zusammengefasst." />
        <Reveal delay={0.2}>
          <div className="card-glass p-7 max-w-sm" data-testid="faq-contact-card">
            <p className="eyebrow !text-[0.6rem] mb-3">Noch offene Fragen?</p>
            <p className="text-sm text-[var(--muted)] leading-relaxed">Ich beantworte Ihre Fragen persönlich – in der Regel innerhalb von 24 Stunden.</p>
            <button onClick={() => scrollToId("kontakt")} className="btn-ghost mt-5 !py-3 !px-5 text-xs" data-testid="faq-cta">Frage stellen</button>
          </div>
        </Reveal>
      </div>
      <Reveal className="lg:col-span-7" delay={0.15}>
        <Accordion type="single" collapsible className="border-t border-[var(--line)]" data-testid="faq-accordion">
          {FAQ.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} className="border-b border-[var(--line)]" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="py-6 lg:py-7 hover:no-underline gap-6 group [&>svg]:hidden" data-testid={`faq-trigger-${i}`}>
                <span className="flex items-start gap-5 text-left">
                  <span className="font-mono text-[0.65rem] tracking-[0.2em] text-[var(--gold)] mt-1.5 shrink-0">0{i + 1}</span>
                  <span className="font-display text-xl lg:text-2xl leading-snug text-[var(--text)] group-hover:text-[var(--gold-3)] transition-colors">{f.q}</span>
                </span>
                <Plus size={18} className="text-[var(--gold)] shrink-0 transition-transform duration-500 group-data-[state=open]:rotate-45" />
              </AccordionTrigger>
              <AccordionContent className="pb-7" data-testid={`faq-content-${i}`}>
                <p className="pl-9 lg:pl-12 text-[var(--muted)] leading-relaxed text-sm lg:text-base max-w-2xl">{f.a}</p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
